var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"custom-mask",attrs:{"id":"cusMask"},on:{"contextmenu":function($event){$event.preventDefault();}}}):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }